import { useState } from "react";
import { commentItems, hotTopics } from "@/mocks/guaData";

const filters = ["全部", "热评", "弹幕", "神梗", "段子"];

export default function HotComments() {
  const [active, setActive] = useState("全部");
  const [liked, setLiked] = useState<Set<string>>(new Set());

  const list =
    active === "全部"
      ? commentItems
      : commentItems.filter((c) => c.tag === active);

  const toggleLike = (id: string) => {
    setLiked((prev) => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return next;
    });
  };

  return (
    <section id="hot" className="bg-background-50 py-14 md:py-20">
      <div className="container-page">
        {/* 热门话题轮播条 */}
        <div className="mb-12">
          <div className="mb-6 flex items-center justify-between">
            <h2 className="heading-font text-2xl text-foreground-950 md:text-3xl">
              🔥 今日热门瓜
            </h2>
            <span className="hidden text-sm text-foreground-500 sm:block">
              热度数据实时累计
            </span>
          </div>
          <div className="no-scrollbar flex gap-4 overflow-x-auto pb-2">
            {hotTopics.map((t) => (
              <a
                key={t.id}
                href="#hot"
                className="group w-60 shrink-0 overflow-hidden rounded-xl bg-background-100 transition-transform hover:-translate-y-1"
              >
                <div className="relative h-32 w-full overflow-hidden">
                  <img
                    src={t.img}
                    alt={`热门话题：${t.title}`}
                    className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                  <span className="absolute left-2 top-2 rounded-full bg-primary-500/90 px-2.5 py-0.5 text-xs text-background-50">
                    {t.tag}
                  </span>
                </div>
                <div className="flex items-center justify-between px-3 py-2.5">
                  <p className="whitespace-nowrap text-sm font-bold text-foreground-900">
                    {t.title}
                  </p>
                  <span className="flex items-center gap-1 whitespace-nowrap text-xs text-foreground-500">
                    <i className="ri-fire-line text-primary-500"></i>
                    {t.heat}
                  </span>
                </div>
              </a>
            ))}
          </div>
        </div>

        {/* 热评列表 */}
        <div className="mb-6 flex items-center justify-between gap-4">
          <h2 className="heading-font text-2xl text-foreground-950 md:text-3xl">
            网友热评精选
          </h2>
        </div>

        <div className="mb-7 flex w-full flex-wrap gap-2 rounded-full border border-background-200 bg-background-100 p-1 sm:w-auto">
          {filters.map((f) => (
            <button
              key={f}
              type="button"
              onClick={() => setActive(f)}
              className={`cursor-pointer rounded-full px-4 py-1.5 text-sm font-bold transition-colors sm:px-5 ${
                active === f
                  ? "bg-primary-500 text-background-50"
                  : "text-foreground-600 hover:bg-background-200"
              }`}
            >
              {f}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          {list.map((c) => (
            <article
              key={c.id}
              className={`animate-pop rounded-2xl bg-background-100 p-5 transition-shadow hover:shadow-md ${
                c.hot ? "ring-1 ring-primary-200" : ""
              }`}
            >
              <div className="flex items-center gap-3">
                <img
                  src={c.avatar}
                  alt={`网友头像 ${c.name}`}
                  className="h-10 w-10 rounded-full object-cover"
                />
                <div className="min-w-0 flex-1">
                  <div className="flex items-center gap-2">
                    <span className="whitespace-nowrap text-sm font-bold text-foreground-900">
                      {c.name}
                    </span>
                    {c.hot && (
                      <span className="rounded-full bg-primary-100 px-2 py-0.5 text-xs text-primary-700">
                        热评
                      </span>
                    )}
                  </div>
                  <p className="truncate text-xs text-foreground-500">
                    话题：{c.topic}
                  </p>
                </div>
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-secondary-100 text-secondary-700">
                  <i className="ri-chat-3-line"></i>
                </span>
              </div>

              <p className="mt-3 text-sm leading-6 text-foreground-800">{c.text}</p>

              <div className="mt-4 flex items-center justify-between text-xs text-foreground-500">
                <span>{c.topic} · 前排围观中</span>
                <div className="flex items-center gap-3">
                  <button
                    type="button"
                    onClick={() => toggleLike(c.id)}
                    className="flex cursor-pointer items-center gap-1 rounded-full px-2 py-1 transition-colors hover:text-primary-600"
                    aria-label="点赞"
                  >
                    <i
                      className={`${
                        liked.has(c.id)
                          ? "ri-heart-3-fill text-primary-500"
                          : "ri-heart-3-line"
                      }`}
                    ></i>
                    {c.likes}
                  </button>
                  <span className="flex items-center gap-1">
                    <i className="ri-chat-smile-2-line"></i>
                    {c.replies}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}